<template>
    <van-popup safe-area-inset-bottom v-model="visible" round position="bottom" :close-on-click-overlay="false">
        <van-picker show-toolbar :title="title" :default-index="defaultindex" visible-item-count="4" :columns="columns" @cancel="cancel" @confirm="confirm" :confirm-button-text="$t('table.confirm')" :cancel-button-text="$t('table.cancel')" />
    </van-popup>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
        columns: {
            type: Array,
            default: () => {
                return [];
            },
        },
        defaultcode: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            active: {},
        };
    },
    created() {},
    computed: {
        defaultindex() {
            let index = 0;
            if (this.defaultcode) {
                index = this.columns.findIndex(
                    (item) => item.code == this.defaultcode
                );
            }
            return index;
        },
    },
    methods: {
        cancel() {
            this.$emit("update:visible", false);
        },
        confirm(item) {
            this.$emit("update:visible", false);
            this.$emit("active", item);
        },
    },
};
</script>
    <style lang='scss' scoped>
/deep/ {
    .van-picker__cancel {
        color: #0e1822;
    }
    .van-picker__confirm {
        color: #28b86a;
    }
    .van-picker-column__item--selected {
        color: #28b86a;
        background: #f6f9fa;
        border-color: #f6f9fa;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/popupobj.vue